import { render } from "./CheckRolePropsCmp.vue?vue&type=template&id=77be0856"
import script from "./CheckRolePropsCmp.vue?vue&type=script&lang=js"
export * from "./CheckRolePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__